﻿import { Container } from 'statuo';

import { pickBy, merge } from 'lodash';

import getCourses from '../../../03-api/teetime/getcourses';

import { getSessionStorage } from '../../session-manager';
import { formatSimpleDate } from '../../utilities/date-formatter';

import saveToSessionStorageTransform from '../transforms/save-to-storage';
import addEndpointResponseTransform from '../transforms/add-endpoint-response';

/* ========================================================================== */

const filtersKey = 'filters',
	today = new Date(),
	currDate = formatSimpleDate(today, '-'),
	initialState = pickBy(
		merge(
			{},
			{
				holes: 0,
				players: 0,
				date: currDate,
				search: null,
				cityId: null,
				courseId: null
			},
			getSessionStorage(filtersKey) || {},
			{
				loopnumber: null,
				coursenumber: null
			}
		),
		// We do this as a trick, to make sure we don't keep ahold of
		// a possible coursenumber and/or loopnumber from a course detail page.
		(value) => value !== null
	),
	responseKey = 'response',
	saveToSessionStorageTransformConfig = {
		storageKey: filtersKey,
		omitKeys: [responseKey]
	},
	addEndpointResponseTransformConfig = {
		endpoint: getCourses,
		omitKeys: [responseKey],
		stateKey: responseKey
	};

/* ========================================================================== */

export default class extends Container {
	constructor() {
		super({
			state: initialState,
			transforms: [
				saveToSessionStorageTransform(saveToSessionStorageTransformConfig),
				addEndpointResponseTransform(addEndpointResponseTransformConfig)
			]
		});
	}
}
